// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"496":"81cf7307","863":"81cf7307"}[chunkId] + ".chunk.css";
};